import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Typography, Divider } from "antd";
import {
  SearchOutlined,
  FileDoneOutlined,
  ImportOutlined,
  FileSearchOutlined,
} from "@ant-design/icons";

const { Text, Title } = Typography;

function MenuPreInvestigateAssets({ onClick }) {
  const navigate = useNavigate();
  const ROLE_ID = localStorage.getItem("ROLE_ID");

  const handleMenuClick = (item) => {
    if (onClick) onClick(item.label); // ส่งชื่อไปที่ Header
    navigate(item.path);
  };

  const menuGroups = [
    {
      groupTitle: "สืบก่อนฟ้อง",
      show: ROLE_ID === "1" || ROLE_ID === "2",

      items: [
        {
          icon: <SearchOutlined />,
          label: "สืบก่อนฟ้อง > ส่งสืบทรัพย์",
          path: "/pre-investigate-assets/send-investigate-assets-online",
          show: true,
        },

        {
          icon: <ImportOutlined />,
          label: "สืบก่อนฟ้อง > นำเข้าสืบก่อนฟ้อง",
          path: "/pre-investigate-assets/import-investigate-assets-online",
          show: true,
        },
        {
          icon: <FileSearchOutlined />,
          label: "สืบก่อนฟ้อง > รายงานข้อมูลทรัพย์",
          path: "/pre-investigate-assets/main-assets-online",
          show: true,
        },
        {
          icon: <FileDoneOutlined />,
          label: "สืบก่อนฟ้อง > เตรียมเอกสารส่งฟ้อง",
          path: "/pre-investigate-assets/check-document",
          show: true,
        },
      ],
    },
  ];

  return (
    <div className="dashboard-wrapper">
      {menuGroups.map(
        (group, gIndex) =>
          group.show && (
            <div key={gIndex}>
              <Divider orientation="left">
                <Title level={4}>{group.groupTitle}</Title>
              </Divider>
              <Row gutter={[24, 24]}>
                {group.items.map(
                  (item, index) =>
                    item.show && (
                      <Col xs={12} sm={8} md={6} lg={4} key={index}>
                        <div
                          className="menu-card"
                          onClick={() => handleMenuClick(item)}
                        >
                          <div className="icon-wrapper">{item.icon}</div>
                          <Text className="menu-text-gold">
                            {
                              item.label.includes(">")
                                ? item.label.split(">")[1] // ถ้ามี '>' ให้เอาตัวหลังสุดมาโชว์
                                : item.label // ถ้าไม่มีให้โชว์ปกติ
                            }
                          </Text>
                        </div>
                      </Col>
                    ),
                )}
              </Row>
            </div>
          ),
      )}
    </div>
  );
}

export default MenuPreInvestigateAssets;
